// extracted by mini-css-extract-plugin
export default {"form":"questionForm_form__6M8Qi","options":"questionForm_options__x8M17","popover":"questionForm_popover__rP92C"};